import * as React from 'react';
import { cn } from '@/lib/utils';

/* shadcn/ui Input. The border uses --input, which shadcn.css points at surface.border-strong: that
 * token exists at 3:1 precisely because a form control border is WCAG 1.4.11. */
export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, type = 'text', ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'h-touch w-full rounded-md border border-input bg-card px-3 text-base text-foreground',
          'placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
